import React, { useEffect, useState } from 'react';
import './index.css';
import MatrixRainBg from './MatrixRainBg';
import CoinAnimation from './CoinAnimation';
import AuthModal from './AuthModal';
import { AuthProvider } from './contexts/AuthContext';
import logo from './logo.svg';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  useEffect(() => {
    // FAQ Toggle Functionality
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      
      question?.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        
        // Close all other FAQ items
        faqItems.forEach(otherItem => {
          otherItem.classList.remove('active');
        });
        
        // Toggle current item
        if (!isActive) {
          item.classList.add('active');
        }
      });
    });
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const openAuthModal = () => {
    setIsAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };



  return (
    <AuthProvider>
    <div className="App">
      <MatrixRainBg />
      {/* Header */}
      <header className="header">
        <nav className="nav">
          <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: '0.1rem' }}>
            <img src={logo} alt="Logo" style={{ height: '28px', verticalAlign: 'middle' }} />
            <span>Trial</span>
          </div>
          
          {/* Hamburger Menu */}
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`} style={{ gap: '1.2rem' }}>
            <li><a href="#home" onClick={closeMenu}>Inicio</a></li>
            <li><a href="#features" onClick={closeMenu}>Características</a></li>
            <li><a href="#security" onClick={closeMenu}>Seguridad</a></li>
            <li><a href="#pricing" onClick={closeMenu}>Precios</a></li>
            <li><a href="#faq" onClick={closeMenu}>FAQ</a></li>
            <li><a href="#about" onClick={closeMenu}>Sobre Nosotros</a></li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content fade-in">
          <h1 className="hero-title gradient-text">Trial</h1>
          <p className="hero-subtitle neon-text">
            La wallet más avanzada para tus criptomonedas. Seguridad y tecnología de última generación.
          </p>
          <button className="btn-download" onClick={openAuthModal}>Descargar App</button>
          <div className="social-links">
            <a href="#" className="social-link">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        <div className="coin-container">
          <CoinAnimation />
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">$2.5B+</div>
            <div className="stat-label">Volumen 24h</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-number">500+</div>
            <div className="stat-label">Pares de Trading</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-number">1M+</div>
            <div className="stat-label">Usuarios Activos</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-number">99.9%</div>
            <div className="stat-label">Uptime</div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <div className="features-content">
          <h2 className="gradient-text">Características Principales</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Seguridad Avanzada</h3>
              <p>Protección de nivel bancario con encriptación de última generación y autenticación multifactor.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3>Transacciones Rápidas</h3>
              <p>Enviá y recibí criptomonedas instantáneamente con nuestra tecnología de procesamiento optimizada.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Análisis en Tiempo Real</h3>
              <p>Monitoreá tus inversiones con gráficos avanzados y alertas personalizadas.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h3>Multiplataforma</h3>
              <p>Accedé a tu wallet desde cualquier dispositivo con sincronización automática.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-headset"></i>
              </div>
              <h3>Soporte 24/7</h3>
              <p>Atención al cliente en todo momento para resolver tus dudas y problemas.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-percent"></i>
              </div>
              <h3>Bajas Comisiones</h3>
              <p>Disfrutá de transacciones con comisiones mínimas y sin costos ocultos.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="container">
          <h2 className="section-title gradient-text">Cómo Funciona</h2>
          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">01</div>
              <div className="step-icon">
                <i className="fas fa-download"></i>
              </div>
              <h3>Descarga la App</h3>
              <p>Descarga Trial Wallet desde la App Store o Google Play Store de forma gratuita.</p>
            </div>
            
            <div className="step-card">
              <div className="step-number">02</div>
              <div className="step-icon">
                <i className="fas fa-user-plus"></i>
              </div>
              <h3>Crea tu Cuenta</h3>
              <p>Regístrate con tu email y configura tu autenticación de dos factores para máxima seguridad.</p>
            </div>
            
            <div className="step-card">
              <div className="step-number">03</div>
              <div className="step-icon">
                <i className="fas fa-wallet"></i>
              </div>
              <h3>Configura tu Wallet</h3>
              <p>Genera tus claves privadas y guarda tu frase de recuperación en un lugar seguro.</p>
            </div>
            
            <div className="step-card">
              <div className="step-number">04</div>
              <div className="step-icon">
                <i className="fas fa-coins"></i>
              </div>
              <h3>¡Comienza a Usar!</h3>
              <p>Ya puedes enviar, recibir y gestionar tus criptomonedas de forma segura.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Cryptocurrencies Section */}
      <section id="cryptocurrencies" className="crypto-section">
        <div className="container">
          <h2 className="section-title gradient-text">Criptomonedas Soportadas</h2>
          <div className="crypto-grid">
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fab fa-bitcoin"></i>
              </div>
              <h3>Bitcoin</h3>
              <p>La primera y más importante criptomoneda del mundo.</p>
              <div className="crypto-price">$43,250.00</div>
            </div>
            
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fab fa-ethereum"></i>
              </div>
              <h3>Ethereum</h3>
              <p>Plataforma para aplicaciones descentralizadas y contratos inteligentes.</p>
              <div className="crypto-price">$2,650.00</div>
            </div>
            
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fas fa-coins"></i>
              </div>
              <h3>Cardano</h3>
              <p>Blockchain de tercera generación con enfoque en escalabilidad.</p>
              <div className="crypto-price">$0.48</div>
            </div>
            
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Solana</h3>
              <p>Blockchain de alto rendimiento para DeFi y NFTs.</p>
              <div className="crypto-price">$98.50</div>
            </div>
            
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fas fa-link"></i>
              </div>
              <h3>Chainlink</h3>
              <p>Red de oráculos descentralizados para datos del mundo real.</p>
              <div className="crypto-price">$15.20</div>
            </div>
            
            <div className="crypto-card">
              <div className="crypto-icon">
                <i className="fas fa-dot-circle"></i>
              </div>
              <h3>Polkadot</h3>
              <p>Protocolo de interoperabilidad entre blockchains.</p>
              <div className="crypto-price">$7.85</div>
            </div>
          </div>
        </div>
      </section>

      {/* Security Section */}
      <section id="security" className="security-section">
        <div className="container">
          <h2 className="section-title gradient-text">Seguridad de Nivel Bancario</h2>
          <div className="security-grid">
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-lock"></i>
              </div>
              <h3>Encriptación AES-256</h3>
              <p>Datos protegidos con el estándar de encriptación más seguro del mundo.</p>
            </div>
            
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-fingerprint"></i>
              </div>
              <h3>Autenticación Biométrica</h3>
              <p>Acceso seguro con huella dactilar o reconocimiento facial.</p>
            </div>
            
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>2FA Obligatorio</h3>
              <p>Autenticación de dos factores para proteger tu cuenta.</p>
            </div>
            
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-cloud"></i>
              </div>
              <h3>Backup Automático</h3>
              <p>Respaldo automático de tus claves en la nube segura.</p>
            </div>
            
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-eye-slash"></i>
              </div>
              <h3>Claves Offline</h3>
              <p>Tus claves privadas nunca salen de tu dispositivo.</p>
            </div>
            
            <div className="security-card">
              <div className="security-icon">
                <i className="fas fa-certificate"></i>
              </div>
              <h3>Auditorías Regulares</h3>
              <p>Auditorías de seguridad independientes cada 6 meses.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing-section">
        <div className="container">
          <h2 className="section-title gradient-text">Planes y Precios</h2>
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Gratuito</h3>
                <div className="price">$0</div>
                <p>Para siempre</p>
              </div>
              <ul className="pricing-features">
                <li><i className="fas fa-check"></i> Wallet básica</li>
                <li><i className="fas fa-check"></i> 5 criptomonedas</li>
                <li><i className="fas fa-check"></i> Soporte por email</li>
                <li><i className="fas fa-check"></i> Transacciones básicas</li>
              </ul>
              <button className="pricing-btn">Comenzar Gratis</button>
            </div>
            
            <div className="pricing-card featured">
              <div className="pricing-header">
                <h3>Pro</h3>
                <div className="price">$9.99</div>
                <p>Por mes</p>
              </div>
              <ul className="pricing-features">
                <li><i className="fas fa-check"></i> Todas las criptomonedas</li>
                <li><i className="fas fa-check"></i> Gráficos avanzados</li>
                <li><i className="fas fa-check"></i> Soporte prioritario</li>
                <li><i className="fas fa-check"></i> Alertas personalizadas</li>
                <li><i className="fas fa-check"></i> Staking automático</li>
              </ul>
              <button className="pricing-btn featured">Comenzar Ahora</button>
            </div>
            
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Enterprise</h3>
                <div className="price">$29.99</div>
                <p>Por mes</p>
              </div>
              <ul className="pricing-features">
                <li><i className="fas fa-check"></i> Todo de Pro</li>
                <li><i className="fas fa-check"></i> API completa</li>
                <li><i className="fas fa-check"></i> Soporte 24/7</li>
                <li><i className="fas fa-check"></i> Múltiples wallets</li>
                <li><i className="fas fa-check"></i> Integración personalizada</li>
              </ul>
              <button className="pricing-btn">Contactar Ventas</button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <h2 className="section-title gradient-text">Lo que Dicen Nuestros Usuarios</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Trial Wallet cambió mi forma de manejar criptomonedas. La interfaz es intuitiva y la seguridad me da total tranquilidad."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="author-info">
                  <h4>María González</h4>
                  <span>Trader Profesional</span>
                </div>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"La mejor wallet que he usado. El soporte al cliente es excepcional y las actualizaciones constantes mantienen la app al día."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="author-info">
                  <h4>Carlos Rodríguez</h4>
                  <span>Inversor HODL</span>
                </div>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>"Como desarrollador, aprecio la API robusta y la documentación clara. Trial Wallet es mi elección para proyectos DeFi."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="author-info">
                  <h4>Ana Martínez</h4>
                  <span>Desarrolladora Blockchain</span>
                </div>
                <div className="rating">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="faq-section">
        <div className="container">
          <h2 className="section-title gradient-text">Preguntas Frecuentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Es Trial Wallet segura?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>Sí, Trial Wallet utiliza encriptación AES-256 y autenticación de dos factores. Tus claves privadas nunca salen de tu dispositivo.</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Qué criptomonedas soporta?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>Soportamos más de 100 criptomonedas incluyendo Bitcoin, Ethereum, Cardano, Solana y muchas más.</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Puedo recuperar mi wallet si pierdo mi teléfono?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>Sí, con tu frase de recuperación de 12 palabras puedes restaurar tu wallet en cualquier dispositivo.</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Hay comisiones por transacciones?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>No cobramos comisiones adicionales. Solo pagas las tarifas de red de cada blockchain.</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Ofrecen soporte al cliente?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>Sí, ofrecemos soporte 24/7 por chat, email y teléfono para usuarios Pro y Enterprise.</p>
              </div>
            </div>
            
            <div className="faq-item">
              <div className="faq-question">
                <h3>¿Puedo usar Trial Wallet en múltiples dispositivos?</h3>
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">
                <p>Sí, puedes sincronizar tu wallet en múltiples dispositivos de forma segura.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Trial Wallet</h3>
            <p>La wallet más avanzada para tus criptomonedas. Seguridad y tecnología de última generación.</p>
          </div>
          
          <div className="footer-section">
            <h3>Productos</h3>
            <button className="footer-link">Wallet Móvil</button><br />
            <button className="footer-link">Wallet Desktop</button><br />
            <button className="footer-link">API</button><br />
            <button className="footer-link">Staking</button>
          </div>
          
          <div className="footer-section">
            <h3>Soporte</h3>
            <button className="footer-link">Centro de Ayuda</button><br />
            <button className="footer-link">Contacto</button><br />
            <button className="footer-link">Estado del Sistema</button><br />
            <button className="footer-link">Documentación</button>
          </div>
          
          <div className="footer-section">
            <h3>Legal</h3>
            <button className="footer-link">Términos de Servicio</button><br />
            <button className="footer-link">Política de Privacidad</button><br />
            <button className="footer-link">KYC/AML</button><br />
            <button className="footer-link">Licencias</button>
          </div>
        </div>
      </footer>
      
      {/* Auth Modal */}
      {isAuthModalOpen && <AuthModal open={isAuthModalOpen} onClose={closeAuthModal} />}
    </div>
    </AuthProvider>
  );
}

export default App;
